// import { HttpErrorResponse } from '@angular/common/http';
// import { Component, OnInit } from '@angular/core';
// import { ApiService } from 'src/app/services/API/api.service';

// @Component({
//   selector: 'app-cart',
//   templateUrl: './cart.component.html',
//   styleUrls: ['./cart.component.scss']
// })
// export class CartComponent implements OnInit {

//   constructor(private api: ApiService) { }
//   cart: any
//   cartData: any

//   ngOnInit(): void {

//     this.api.getMyCart().subscribe({
//         next: (response) => {
//           this.cart = response.data

//           this.cartData = {
//             products: this.cart.map(item => ({
//                 product_id: item.id,
//                 type: item.selectedTypeId, // Using the selectedTypeId from your cart items
//                 quantity: item.quantity // Using the quantity from your cart items
//             }))
//           };

//           console.log(this.cartData)
//         }, error: (error: HttpErrorResponse) => {
//             console.log(error)
//         }
//     })
//   }

//   getTypeName(types: any[], selectedTypeId: number): string {
//     const type = types.find(t => t.id === selectedTypeId);
//     return type ? type.name : '';
//   }

//   getTypePrice(types: any[], selectedTypeId: number): number {
//     const type = types.find(t => t.id === selectedTypeId);
//     return type ? type.price : 0;
//   }

//   calculateSubtotal(item: any): number {
//     const price = this.getTypePrice(item.types, item.selectedTypeId);
//     let subtotal = price * item.quantity;
    
//     // Apply discount if there's an offer
//     if (item.offer && item.offer.type === 'discount') {
//         subtotal = subtotal * (1 - (item.offer.value / 100));
//     }
    
//     return subtotal;
//   }

//   increaseQuantity(item: any) {
//     item.quantity++;
//     // You might want to update your cart service here
//   }

//   decreaseQuantity(item: any) {
//     if (item.quantity > 1) {
//         item.quantity--;
//         // You might want to update your cart service here
//     }
//   }

//   removeItem(item: any) {
//     // Implement your remove item logic here
//     // For example: this.cartService.removeFromCart(item);
//   }

// }
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/services/API/api.service';
import { NavbarStyleOneComponent } from '../../common/navbar-style-one/navbar-style-one.component';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {

  constructor(private api: ApiService) { }
  cart: any[] = []; // Initialize as empty array
  cartData: any;
  showSuccess: boolean = false;
  successMsg = '';
  showError: boolean = false;
  errorMsg = '';

  ngOnInit(): void {
    this.loadCart();
    this.setDeliveryMethodToDelivery()
  }

  setDeliveryMethodToDelivery(){
    localStorage.setItem('deliveryMethod','delivery')
  }

  loadCart() {
    this.api.getMyCart().subscribe({
      next: (response) => {
        this.cart = response.data;
        this.updateCartData();
      }, 
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    });
  }

  // Helper method to keep cartData in sync
  updateCartData() {
    this.cartData = {
      products: this.cart.map(item => ({
        product_id: item.id,
        type: item.selectedTypeId,
        quantity: item.quantity
      }))
    };
    console.log('Updated cart data:', this.cartData);
    if(this.cartData){
      this.updateCartOnServer()
    }
  }

  getTypeName(types: any[], selectedTypeId: number): string {
    const type = types.find(t => t.id === selectedTypeId);
    return type ? type.name : '';
  }

  getTypePrice(types: any[], selectedTypeId: number): number {
    const type = types.find(t => t.id === selectedTypeId);
    return type ? type.price : 0;
  }

  calculateSubtotal(item: any): number {
    const price = this.getTypePrice(item.types, item.selectedTypeId);
    let subtotal = price * item.quantity;
    
    if (item.offer && item.offer.type === 'discount') {
      subtotal = subtotal * (1 - (item.offer.value / 100));
    }
    
    return subtotal;
  }

  increaseQuantity(item: any) {
    item.quantity++;
    this.updateCartData();
    // this.updateCartOnServer(); // Optional: Send to server
  }

  decreaseQuantity(item: any) {
    if (item.quantity > 1) {
      item.quantity--;
      this.updateCartData();
      // this.updateCartOnServer(); // Optional: Send to server
    }
  }

  removeItem(item: any,id?: number) {
    // Remove from local cart array
    this.cart = this.cart.filter(cartItem => 
      !(cartItem.id === item.id && cartItem.selectedTypeId === item.selectedTypeId)
    );

    this.api.removeCart(id).subscribe({
      next: (response) => {
        console.log(response);
        this.showSuccess = true;
        this.successMsg = 'تم حذف المنتج بنجاح';
        setTimeout(() => {
          this.showSuccess = false;
          this.successMsg = '';
        },2000);
      }, error: (error: HttpErrorResponse) => {
        console.log(error)
      }
    })
    
    this.updateCartData();
    this.updateCartOnServer(); // Optional: Send to server
  }

  // Optional: Method to update cart on server
  @ViewChild(NavbarStyleOneComponent) navbarComponent: NavbarStyleOneComponent;
  updateCartOnServer() {
    this.api.addToCart(this.cartData).subscribe({
      next: (response) => {
        console.log('Cart updated on server', response);
        this.showSuccess = true;
        this.successMsg = 'تم تحديث السلة بنجاح';
        this.navbarComponent.getCart()
        setTimeout(() => {
          this.showSuccess = false;
          this.successMsg = '';
        },2000);
      },
      error: (error) => {
        console.error('Error updating cart', error);
      }
    });
  }

  setDeliveryMethod(method: string){
    localStorage.setItem('deliveryMethod',method)
  }

}